export const DEFAULT_YEAR = 2026;

export const businessPlanningCategoryMap = {
  factory: "ADVANCED",
  onshore: "ONSHORE",
  service: "SERVICE",
};

export const normalizeSegmentKey = (value = "") => {
  const normalizedValue = value.toLowerCase();
  if (normalizedValue.includes("factory")) return "factory";
  if (normalizedValue.includes("onshore")) return "onshore";
  if (normalizedValue.includes("service")) return "service";
  return "factory";
};

export const formatSegmentTitle = (value = "") => {
  const segmentKey = normalizeSegmentKey(value);
  return segmentKey.charAt(0).toUpperCase() + segmentKey.slice(1);
};

export const formatTableCellValue = (value, allowZeroAsDash = false) => {
  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) return "-";
  if (allowZeroAsDash && parsedValue === 0) return "-";
  return parsedValue.toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
};

export const isTotalRow = (category = "") => {
  const lower = category.toLowerCase().trim();
  return lower.includes("total") || lower === "others" || /^tata\s*[\d&]/i.test(category.trim());
};

export const transformApiItems = (items = []) => {
  const categoryMap = {};
  const monthColumns = [];

  items.forEach(({ MonthYear, data }) => {
    const colKey = `${MonthYear}_Value`;
    monthColumns.push({ key: colKey, title: MonthYear.replace("_", " ") });

    (data || []).forEach(({ Category, Value }) => {
      if (!categoryMap[Category]) {
        categoryMap[Category] = { Category };
      }
      categoryMap[Category][colKey] = Value;
    });
  });

  const rows = Object.values(categoryMap).sort((a, b) => {
    const aIsTotal = a.Category.toLowerCase() === "grand total";
    const bIsTotal = b.Category.toLowerCase() === "grand total";
    if (aIsTotal) return 1;
    if (bIsTotal) return -1;
    return 0;
  });

  return { rows, monthColumns };
};
